import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { resetPaymentStatus } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import { addNewCardDefaultValues, getAddnewCardBaseTemplate, redirectBackToPayment } from '../utils/AddNewCardUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { useAppDispatch } from '@kfc-global/react-shared/redux/Store/hooks';
import { isCurrentPageRedirectFromRNA } from 'common/utilities/utils';
import { SAVED_CARDS } from 'common/constants/SharedConstants';

const AddNewCreditAndDebitCardContainer = params => {
  const [paymentDetails, setPaymentDetails] = useState(addNewCardDefaultValues);
  const { tenantReducer, profileReducer } = useSelector(data => data);
  const updateSaveCardDetails = useCallback(param => {
    setPaymentDetails && setPaymentDetails(prevState => ({ ...prevState, ...param }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();
  const sliceDispatch = useAppDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch &&
      updateSaveCardDetails({
        dispatch,
        history,
        sliceDispatch,
        tenantId: tenantReducer?.tenantId,
        paymentProvider: tenantReducer?.componentOptions?.payment?.paymentProvider,
        savedCards: profileReducer?.savedCards ?? [],
        customerId: profileReducer?.customerId,
        firstName: profileReducer?.basic?.firstName,
        lastName: profileReducer?.basic?.lastName,
        countryCodeNumeric: tenantReducer?.countryCodeNumeric,
        nameOnCardRegex: tenantReducer?.componentOptions?.checkout?.nameOnCardRegex,
      });
    dispatch && dispatch(resetPaymentStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const urlparmas = new URLSearchParams(window?.location?.search);
    const savedCardArray = urlparmas.get(SAVED_CARDS);
    const savedCardData = JSON.parse(decodeURIComponent(savedCardArray));
    isCurrentPageRedirectFromRNA?.(window?.location) &&
      updateSaveCardDetails({
        savedCards: savedCardData ?? [],
        nameOnCardRegex: tenantReducer?.componentOptions?.checkout?.nameOnCardRegex,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const props = { paymentDetails, updateSaveCardDetails };
  return (
    <>
      <div className='my-payment-methods-header-mobile'>
        <ImageComponent
          srcFile={IMAGE_PATH.SingleArrowback}
          className='backArrow-account-setting'
          data-testid='backArrow-account-setting'
          onClick={() => redirectBackToPayment(history)}
        />
        <span className='payment-methods-heading-headertext'>
          {' '}
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.MY_PAYMENT_METHODS)}
        </span>
      </div>
      <div className='add-newcard-conatiner'>{getAddnewCardBaseTemplate(props)}</div>
    </>
  );
};

export default AddNewCreditAndDebitCardContainer;
